/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BareTokenHolder,
    BareTokenHolderFromJSON,
    BareTokenHolderFromJSONTyped,
    BareTokenHolderToJSON,
    List,
    ListFromJSON,
    ListFromJSONTyped,
    ListToJSON,
    TokenHolderListAllOf,
    TokenHolderListAllOfFromJSON,
    TokenHolderListAllOfFromJSONTyped,
    TokenHolderListAllOfToJSON,
} from './';

/**
 * 
 * @export
 * @interface TokenHolderList
 */
export interface TokenHolderList {
    /**
     * The total number of records that match the query, i.e. the number of records
     * the query would return with limit=infinity.
     * @type {number}
     * @memberof TokenHolderList
     */
    total_count: number;
    /**
     * Whether total_count is clipped for performance reasons.
     * @type {boolean}
     * @memberof TokenHolderList
     */
    is_total_count_clipped: boolean;
    /**
     * 
     * @type {Array<BareTokenHolder>}
     * @memberof TokenHolderList
     */
    holders: Array<BareTokenHolder>;
}

export function TokenHolderListFromJSON(json: any): TokenHolderList {
    return TokenHolderListFromJSONTyped(json, false);
}

export function TokenHolderListFromJSONTyped(json: any, ignoreDiscriminator: boolean): TokenHolderList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'total_count': json['total_count'],
        'is_total_count_clipped': json['is_total_count_clipped'],
        'holders': ((json['holders'] as Array<any>).map(BareTokenHolderFromJSON)),
    };
}

export function TokenHolderListToJSON(value?: TokenHolderList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'total_count': value.total_count,
        'is_total_count_clipped': value.is_total_count_clipped,
        'holders': ((value.holders as Array<any>).map(BareTokenHolderToJSON)),
    };
}


